/** @jsx jsx */
import React from 'react';
import { useIntl } from 'react-intl-next';
import { jsx } from '@emotion/react';
import { ResourcedEmoji } from '@atlaskit/emoji';
import { i18n, utils } from '../../shared';
import * as styles from './styles';
export var RENDER_BUTTON_TESTID = 'button-emoji-id';
/**
 * custom button to render the custom emoji selector inside the reaction picker
 */
export var EmojiButton = function EmojiButton(_ref) {
  var emojiId = _ref.emojiId,
    onClick = _ref.onClick,
    emojiProvider = _ref.emojiProvider;
  var onButtonClick = function onButtonClick(event) {
    event.preventDefault();
    if (onClick && utils.isLeftClick(event)) {
      onClick(emojiId, undefined, event);
    }
  };
  var intl = useIntl();
  return jsx("button", {
    "data-testid": RENDER_BUTTON_TESTID,
    onClick: onButtonClick,
    "aria-label": intl.formatMessage(i18n.messages.reactWithEmoji, {
      emoji: emojiId.shortName
    }),
    type: "button",
    css: styles.emojiButtonStyle
  }, jsx(ResourcedEmoji, {
    emojiProvider: emojiProvider,
    emojiId: emojiId
  }));
};